export default __webpack_public_path__ + "splash-06.3885d.svg";